import { useCallback, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { interoperabilityApi } from '../api/interoperability.api';

export const useMetrics = () => {
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const fetchMetrics = useCallback(async () => {
    setLoading(true);
    try {
      const response = await interoperabilityApi.getMetrics();
      setEntities(response);
      return response;
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
      return [];
    } finally {
      setLoading(false);
    }
  }, [searchValue]);

  return {
    entities,
    setEntities,
    fetchMetrics,
    loading,
    searchValue,
    setSearchValue,
  };
};
